import {
  MESSAGE_STR_TYPE_CONFIRMATION,
  MESSAGE_STR_TYPE_WELCOME
} from 'Constants/index'
import { notifyParent } from 'mailup-react-helpers'

function modalMessageRedirect(history) {
  const redirect = (messageType) => {
    switch (messageType) {
      case MESSAGE_STR_TYPE_WELCOME: {
        notifyParent('redirectMainFrame', [
          `databasebuilding_app_redirector.aspx?r=${encodeURIComponent(
            '/databasebuilding/subscriptions/welcome/list'
          )}`
        ])
        break
      }
      case MESSAGE_STR_TYPE_CONFIRMATION: {
        notifyParent('redirectMainFrame', [
          `databasebuilding_app_redirector.aspx?r=${encodeURIComponent(
            '/databasebuilding/subscriptions/confirmation/list'
          )}`
        ])
        break
      }
      default: {
        history.push('/messages/email/saved')
        break
      }
    }
  }
  return { redirect }
}

export default modalMessageRedirect
